export default __webpack_public_path__ + "static/media/pm.2954d692.svg";